import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=23a99579"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports